import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { AwardModal } from 'components/awardModal/awardModal'
import CircularCarousel from 'components/carousel/Carousel'
import CategorySection from 'components/categorySection/CategorySection'
import QuestionsBanner from 'components/categorySection/QuestionsBanner'
import BottomArc from 'components/common/bottomArc/BottomArc'
import FaqSection from 'components/faqSection/FaqSection'
import { HelpBanner } from 'components/HelpBanner'
import Hero from 'components/hero/Hero'
import { AnalyticsActionType } from 'types/analytics.type'
import { ANALYTICS_EVENTS, trackAnalytics } from 'utils/analytics'

export function App() {
  const handleAnalytics = () => {
    trackAnalytics({
      type: AnalyticsActionType.page,
      payload: ANALYTICS_EVENTS.PAGEVIEW.LANDING,
    })
  }

  useEffect(() => {
    handleAnalytics()
  }, [])
  return (
    <BrowserRouter basename="/nma-home">
      <div className="tour-nma-welcome bg-white min-h-[calc(100vh-var(--wpp-os-header-height))] m-[0_auto]">
        <Hero />
        <CategorySection />
        <CircularCarousel />
        {/*<NominationList />*/}
        <QuestionsBanner />
        <FaqSection />
        <HelpBanner />
      </div>
      <BottomArc />
      <AwardModal />
    </BrowserRouter>
  )
}
